// Where a signed-in role belongs, shared by all four private routes.
//
// Each route used to carry its own copy whose `default:` case pointed at ITS OWN
// dashboard — so a session holding a token but no recognizable role redirected
// to a route that immediately redirected to itself. That is an infinite render
// loop (React error #185, "Maximum update depth exceeded"), which takes the whole
// app down as hard as any crash. A role-less session is not a routing question,
// it is a broken session: send it to the logged-out entry, which is not a
// private route and therefore terminates.

export const ROLE_HOME = {
  tribunal: "/admin", // tribunal === admin
  jury: "/jury/dashboard",
  custodian: "/custodian/dashboard",
  user: "/user/dashboard",
};

export const LOGGED_OUT_HOME = "/";

/**
 * @returns the dashboard for a KNOWN role, or the logged-out entry for anything
 * unrecognized. Never returns a private route for an unknown role.
 */
export const dashboardFor = (role) =>
  Object.prototype.hasOwnProperty.call(ROLE_HOME, role)
    ? ROLE_HOME[role]
    : LOGGED_OUT_HOME;
